import { environment } from "../../../../environments/environment";
import { Icd10Item } from "../../../shared-components/eCIT/e-cit.types";
import axios from 'axios';

export const getMyFavouriteIcd10Codes = async (): Promise<Icd10Item[]> => {
  const options = {
    method: "GET",
    url: `${environment.apiUrl}api/ecit/getMyFavouriteIcd10Codes/`,
  };

  try {
    const { data } = await axios.request(options);
    return data as Icd10Item[];
  } catch (error) {
    console.devlog(error);
    return [];
  }
};

export const updateMyFavouriteIcd10Codes = async (codes: Icd10Item[]): Promise<Icd10Item[]> => {
  const options = {
    method: "POST",
      maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/ecit/updateMyFavouriteIcd10Codes/`,
    headers: {
      "Content-Type": "application/json",
    },
    // The controller reads `ctx.request.body.favouriteIcd10Codes` and stores it
    // verbatim, so send the envelope it expects and only the persisted fields —
    // display-only flags (e.g. `isFavourite`) must not end up in the record.
    data: {
      favouriteIcd10Codes: codes.map(({ shortcode, code, description }) => ({
        shortcode,
        code,
        description,
      })),
    },
  };

  const { data } = await axios.request(options);
  console.devlog(data);
  return data as Icd10Item[];
};
